export const TOKEN_CONSTANTS = {
  PENDING: 'pending', 
  ACTIVE: 'active',
  EXPIRED: 'expired',
  REVOKED: 'revoked',
  INVALID: 'invalid', 
}